import React from 'react'
export default function Button({onClick, label, color, text, outlined, disabled, children, type="button", className='', justify="center", buttonClassName }){
    let css = ''
    if(!color) color = 'primary'

    if(text || outlined){
        css = `text-${text} ${outlined ? 'outline' : ''} bg-${color} hover:bg-opacity-[.7]  ${disabled ? 'grayscale-[75%]' : 'hover:bg-opacity-[.05]'}`
    } else {
        css = `bg-${color} text-white ${disabled ? 'grayscale-[75%]' : 'hover:bg-opacity-[.9]'}`
    }
    return (
        <div className={className}>
            <button
                type={type}
                onClick={onClick}
                className={ `justify-${justify} inline-flex  items-center rounded-lg px-4 py-2 text-sm font-medium
                    ${css} ${buttonClassName}
                    `
                    }
                disabled={disabled}
            >
            { children && children }
            { !children && label }
            </button>
        </div>
    )
}